<n-slide-window *ngIf="pageReady"
    [(visible)]="windowVisible"
    width="7rem"
    (onHide)="close()">
    <n-header>
        <h1>{{winTitle}}</h1>
        <n-help-link key="qoutaCreate"></n-help-link>
    </n-header>

    <form>
        <n-form-item [label]="selectTypeLab">
            <n-radio-group [block]="true"
                [(ngModel)]="selectType"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="onSelectTypeChange()">
                <ng-container *ngFor="let item of selectTypeOpts">
                    <n-radio [value]="item.value">
                        <span>{{item.label}}</span>
                    </n-radio>
                    <p class="sub pl-20">{{item.data}}</p>
                </ng-container>
            </n-radio-group>
        </n-form-item>
    </form>
    <h3 class="mb-15" style="font-size: .14rem;" *ngIf="selectType !== SelectTypeE.Every">
        {{ i18n.selectionTitle }}
    </h3>
    <div class="table-layout" *ngIf="selectType !== SelectTypeE.Every">
        <div class="table-operation">
            <n-button-group [relateTable]="userInGrouDt"
                [items]="[addBtn, removeBtn]">
            </n-button-group>
        </div>
        <div class="table-container">
            <n-tip *ngIf="showErrorMsg"
                [type]="'failed'"
                [content]="i18n.atLeastAddOneTip">
            </n-tip>
            <n-data-table id="select-user-specific-user-in-group"
                #userInGrouDt
                [config]="tableConfig"
                [columnDefs]="tableColumns"
                [data]="getType() === 'user' ? users : userGroups"
                [(selection)]="selection">
                <ng-template nTemplate
                    [meta]="{ field: 'operation' }"
                    let-data="rowData">
                    <a [attr.id]="data.id + '_remove_btn'" (click)="remove(data)">{{i18n.removeBtn}}</a>
                </ng-template>
            </n-data-table>
        </div>
    </div>

    <n-footer>
        <button id="select-user-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="select-user-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
